import { useEffect, useState } from 'react';

const DEFAULT_TAGLINE = 'Operational Discipline Operating System';

// Live platform version + admin-editable tagline/strapline for the login page.
export default function useLoginMeta() {
  const [meta, setMeta] = useState({ tagline: DEFAULT_TAGLINE, strapline: '', version: null, date: null });

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/login-meta?t=${Date.now()}`, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (cancelled || !d) return;
        setMeta({
          tagline: d.tagline || DEFAULT_TAGLINE,
          strapline: d.strapline || '',
          version: d.version,
          date: d.date,
        });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return meta;
}
